import { AttributesSelector, Box, Select } from '@workwhile/ui'
import React, { useMemo } from 'react'

export type GroupByOption = { label: string; value: string }

type GroupByAttributesSelectorProps = {
  label: string
  filterKey: string
  options: GroupByOption[]
  value: string
  onChange: (value: string) => void
  rootGroupTitle?: string
  placeholder?: string
}

/** Single-select grouping control styled like Review Types in AdminReviewStatsChart. */
export function GroupByAttributesSelector({
  label,
  filterKey,
  options,
  value,
  onChange,
  rootGroupTitle = 'Group by',
  placeholder,
}: GroupByAttributesSelectorProps) {
  const selectedAttributes = useMemo(() => {
    const option = options.find((candidate) => candidate.value === value)
    return option ? [option.label] : []
  }, [value, options])

  const resetToDefault = () => {
    const fallback = options[0]?.value
    if (fallback) onChange(fallback)
  }

  return (
    <AttributesSelector
      label={label}
      rootGroupTitle={rootGroupTitle}
      selectedAttributes={selectedAttributes}
      onClearAll={resetToDefault}
      groups={
        <AttributesSelector.Group
          key={filterKey}
          title={label}
          numberOfSelectedAttributes={selectedAttributes.length}
        >
          <Box>
            <Select
              options={options}
              placeholder={placeholder ?? `Select ${label.toLowerCase()}...`}
              value={
                options.find((candidate) => candidate.value === value) ?? null
              }
              onChange={(option) => {
                if (option) onChange(option.value)
              }}
            />
          </Box>
        </AttributesSelector.Group>
      }
    />
  )
}
